// src/pages/ShopPage.jsx - VERSION RESPONSIVE
import React, { useState } from 'react';
import { FaShoppingCart, FaSearch, FaFilter, FaStar, FaPlus } from 'react-icons/fa';
import '../styles/ShopPage.css';

const ShopPage = () => {
  const [activeCategory, setActiveCategory] = useState('bebidas');
  const [searchTerm, setSearchTerm] = useState('');
  const [cart, setCart] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Datos de productos por categoría
  const products = {
    bebidas: [
      {
        id: 1,
        name: "Reanimeitor Clásico",
        price: 0.004,
        image: "/Assets/reanimeitor-lata.png",
        description: "Bebida energética original con taurina y vitaminas",
        category: "bebidas",
        stock: 50,
        rating: 4.8,
        tokenBonus: "+1 BGP"
      },
      {
        id: 2,
        name: "Reanimeitor Zero",
        price: 1.25,
        image: "/Assets/reanimeitor-zero.png",
        description: "Sin azúcar, misma energía",
        category: "bebidas",
        stock: 30,
        rating: 4.6,
        tokenBonus: "+1 BGP"
      },
      {
        id: 3,
        name: "Reanimeitor Turbo",
        price: 1.35,
        image: "/Assets/reanimeitor-turbo.png",
        description: "Doble potencia energética",
        category: "bebidas",
        stock: 25,
        rating: 4.9,
        tokenBonus: "+1 BGP"
      },
      {
        id: 4,
        name: "Pack 6 Reanimeitors",
        price: 6.00,
        image: "/Assets/pack-6.png",
        description: "Ahorra comprando en pack",
        category: "bebidas",
        stock: 15,
        rating: 4.7,
        tokenBonus: "+6 BGP"
      }
    ],
    suplementos: [
      {
        id: 5,
        name: "Cápsulas Energéticas",
        price: 12.99,
        image: "/Assets/capsulas.png",
        description: "Energía concentrada en cápsulas",
        category: "suplementos",
        stock: 20,
        rating: 4.5,
        tokenBonus: "+5 BGP"
      },
      {
        id: 6,
        name: "Vitaminas B-Complex",
        price: 15.50,
        image: "/Assets/vitaminas-b.png",
        description: "Complejo vitamínico esencial",
        category: "suplementos",
        stock: 18,
        rating: 4.4,
        tokenBonus: "+6 BGP"
      },
      {
        id: 7,
        name: "Taurina Pura",
        price: 9.99,
        image: "/Assets/taurina.png",
        description: "Taurina 100% pura en polvo",
        category: "suplementos",
        stock: 12,
        rating: 4.3,
        tokenBonus: "+3 BGP"
      }
    ],
    polvos: [
      {
        id: 8,
        name: "Energy Powder",
        price: 18.99,
        image: "/Assets/energy-powder.png",
        description: "Polvo energético para mezclar",
        category: "polvos",
        stock: 22,
        rating: 4.6,
        tokenBonus: "+8 BGP"
      },
      {
        id: 9,
        name: "Pre-Workout",
        price: 24.99,
        image: "/Assets/pre-workout.png",
        description: "Mezcla pre-entrenamiento",
        category: "polvos",
        stock: 16,
        rating: 4.7,
        tokenBonus: "+10 BGP"
      },
      {
        id: 10,
        name: "Recovery Mix",
        price: 21.50,
        image: "/Assets/recovery-mix.png",
        description: "Recuperación post-entrenamiento",
        category: "polvos",
        stock: 14,
        rating: 4.5,
        tokenBonus: "+9 BGP"
      }
    ]
  };

  const categories = [
    { id: 'bebidas', name: '🥤 Bebidas Energéticas', count: products.bebidas.length },
    { id: 'suplementos', name: '💊 Suplementos', count: products.suplementos.length },
    { id: 'polvos', name: '⚗️ Polvos', count: products.polvos.length }
  ];

  const filteredProducts = products[activeCategory].filter(product =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    product.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const addToCart = (product) => {
    setCart([...cart, product]);
    // Feedback visual mejorado para móvil
    console.log(`${product.name} añadido al carrito`);
    // Aquí podrías añadir un toast notification
  };

  const getCartCount = () => {
    return cart.reduce((total, item) => total + 1, 0);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="shop-page">
      {/* Efectos eléctricos de fondo */}
      <div className="energy-field-shop">
        <div className="energy-bolt-shop"></div>
        <div className="energy-bolt-shop"></div>
        <div className="energy-bolt-shop"></div>
      </div>

      {/* Header de la Tienda */}
      <section className="shop-hero">
        <div className="hero-content">
          <h1>🛒 Tienda Reanimeitor</h1>
          <p>Descubre nuestra gama completa de productos energéticos</p>
          
          {/* Barra de búsqueda */}
          <div className="search-bar">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Buscar productos..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
            <FaFilter className="filter-icon" onClick={toggleSidebar} />
          </div>
        </div>
      </section>

      <div className="shop-container">
        {/* Sidebar de Categorías */}
        <aside className={`categories-sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}>
          <h3>Categorías</h3>
          <div className="categories-list">
            {categories.map(category => (
              <button
                key={category.id}
                className={`category-btn ${activeCategory === category.id ? 'active' : ''}`}
                onClick={() => {
                  setActiveCategory(category.id);
                  setIsSidebarOpen(false); // Cerrar sidebar en móvil al seleccionar
                }}
              >
                <span className="category-name">{category.name}</span>
                <span className="category-count">{category.count}</span>
              </button>
            ))}
          </div>

          {/* Carrito Flotante */}
          <div className="cart-summary">
            <div className="cart-header">
              <FaShoppingCart className="cart-icon" />
              <span>Tu Carrito</span>
              <span className="cart-count">{getCartCount()}</span>
            </div>
            <button className="view-cart-btn">
              Ver Carrito ({getCartCount()})
            </button>
          </div>
        </aside>

        {/* Productos */}
        <main className="products-main">
          <div className="products-header">
            <h2>{categories.find(cat => cat.id === activeCategory)?.name}</h2>
            <p>{filteredProducts.length} producto{filteredProducts.length !== 1 ? 's' : ''} encontrado{filteredProducts.length !== 1 ? 's' : ''}</p>
          </div>

          <div className="products-grid2">
            {filteredProducts.map(product => (
              <div key={product.id} className="product-card">
                <div className="product-image">
                  <img 
                    src={product.image} 
                    alt={product.name}
                    loading="lazy" // Mejora rendimiento en móvil
                  />
                  <div className="product-badge">{product.tokenBonus}</div>
                  <div className="rating">
                    <FaStar className="star-icon" />
                    <span>{product.rating}</span>
                  </div>
                </div>
                
                <div className="product-info">
                  <h3>{product.name}</h3>
                  <p className="product-description">{product.description}</p>
                  
                  <div className="stock-info">
                    <span className={`stock-status ${product.stock > 10 ? 'in-stock' : 'low-stock'}`}>
                      {product.stock > 10 ? 'En stock' : 'Últimas unidades'}
                    </span>
                  </div>

                  <div className="product-footer">
                    <div className="price-section">
                      <span className="price">€{product.price.toFixed(2)}</span>
                      <span className="token-info">+ tokens BGP</span>
                    </div>
                    <button 
                      className="add-to-cart-btn"
                      onClick={() => addToCart(product)}
                      aria-label={`Añadir ${product.name} al carrito`}
                    >
                      <FaPlus className="plus-icon" />
                      Añadir
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Mensaje si no hay productos */}
          {filteredProducts.length === 0 && (
            <div className="no-products">
              <h3>No se encontraron productos</h3>
              <p>Intenta con otros términos de búsqueda o selecciona otra categoría</p>
            </div>
          )}
        </main>
      </div>

      {/* Banner de Promoción */}
      <section className="promo-banner">
        <div className="promo-content">
          <h3>🎁 ¡Envío Gratis en pedidos superiores a €20!</h3>
          <p>Además, recibe tokens BGP extra en tu primera compra</p>
        </div>
      </section>
    </div>
  );
};

export default ShopPage;